import axios from "axios";
import React, { useEffect, useState } from "react";
import Approved from "../../../../../assets/images/approved.png";
import AllDataHeader from "../../../../Reuseable/AllDataHeader";
import AllModuleData from "../../../../Reuseable/AllModuleData";
import LoaderPost from "../../../../Reuseable/LoaderPost";

const LearningSessionEvaluation = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState(0);
  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get(`/api/admin/learning_session/evaluation`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Pending Learning Session"
        image={Approved}
        count={count}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`/superstar-admin/learning-session/evaluation`}
        />
      )}
    </>
  );
};

export default LearningSessionEvaluation;
